<template>
    <div ref="parent" class="goals r v--20">
        <!-- {{ goal }} -->
        <!-- {{ goal_set }} -->
        <div v-if="goal" class="goals__responses r input input--text">
            <div v-for="(response, i) in goal_set.questions" class="goals__responses__response">
                <label v-text="response.question" class="goals__responses__response__label type--h3--default" style="margin-bottom: 8px;"></label>
                <!-- Need to figure out how to recall this later -->
                <!-- :value="siloData.user.modules[responsesMetaString][i].question" -->
                <input
                    type="text"
                    :value="getTextFieldValue(i)"
                    :maxlength="150"
                    @keyup="$emit('validate')"
                    data-watch-event="keyup"
                    data-pristine-not-blank
                    required
                    class="goals__responses__response__answer answer"
                >
                <input type="hidden" class="question" :value="response.question" readonly/>
                <input type="hidden" class="question_short" :value="response.question_short" readonly/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pulledInputs: this.field.pull_input_data !== "" ? this.siloData.user.modules[this.field.pull_input_data] : null,
            currentChecked: "",
            goalMetaString: "meta_goals_goal",
            responsesMetaString: "meta_goals_responses",
            sets: [
                {
                    goal: "Increase engagement with hobbies or pleasurable activities",
                    questions: [
                        {
                            question: "What specific hobbies or activities?",
                            question_short: "Hobbies or activities",
                        },
                        {
                            question: "How often will you do them to start?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Spend more time with family or friends",
                    questions: [
                        {
                            question: "Who specifically would you like to spend more time with?",
                            question_short: "Who",
                        },
                        {
                            question: "What activities can you do together?",
                            question_short: "What activities",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Be more physically active",
                    questions: [
                       {
                            question: "What specific physical activities?",
                            question_short: "What physical activities",
                        },
                        {
                            question: "How often will you do them to start?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Improve pain by using this program",
                    questions: [
                       {
                            question: "How often would you like to use it?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Reduce use of pain medications",
                    questions: [
                       {
                            question: "How often would you like to use it?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Reduce use of alcohol",
                    questions: [
                       {
                            question: "How often would you like to use it?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
                {
                    goal: "Reduce use of marijuana",
                    questions: [
                       {
                            question: "How often would you like to use it?",
                            question_short: "How often",
                        },
                        {
                            question: "What days/times of day will work best for you?",
                            question_short: "What days/times",
                        },
                    ]
                },
            ]
        }
    },
    props: {
        field: Object,
        siloData: Object,
    },
    computed: {
        goal() {
            return this.siloData.user.modules[this.goalMetaString];
        },
        goal_set() {
            return this.sets.find(set => set.goal === this.goal) || null;
        },
    },
    methods: {
        getTextFieldValue(index) {
            return this.siloData.user.modules[this.responsesMetaString][index] ? this.siloData.user.modules[this.responsesMetaString][index].answer : "";
        },
        onChangeEvent(event) {
            console.log('and change event fired');
            this.$emit('validate');
        },
    }, 
}
</script>
<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

input[type="text"][readonly] {
    border: 0;
    padding: 0;
    box-shadow: inherit !important;
    min-height: inherit;
}

.goals__responses {
    margin-top: rem(15px);
    gap: rem(20px);
}

.goals__responses__response {

}

.goals__responses__response__label {
}

.goals__responses__response__answer {
    margin-top: rem(8px);

}

</style>